import { Component, OnInit, effect, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PrivacyPolicyService } from 'src/app/privacy-policy/service/privacy-policy.service';
import { SharedSignalsService } from '../../services/shared-signals.service';

@Component({
    selector: 'taly-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    providers: [PrivacyPolicyService],
    standalone: false
})
export class PrivacyPolicyCommonComponent implements OnInit {

  transferSignal = inject(SharedSignalsService);
  textDirection:any;

  content:any;

  constructor(private privacyService : PrivacyPolicyService, private sanitizer: DomSanitizer){
    effect(() => { 
      this.textDirection = this.transferSignal.textDirection();
    })
  }

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.getTerms();
  }

  getTerms(){
    this.privacyService.getPrivacyPolicy('PRIVACY_POLICY').subscribe( resp =>{
      this.content = resp;
    }, err => {
      this.transferSignal.showMessage('error', err?.message || err)
    })
  }

  sanitizerContent(htmlContent:any){
    return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
  }
}